import { tv } from 'tailwind-variants'

const sharedTextTrigger = tv({
  base: 'grid w-full grid-flow-col items-center gap-x-1 border-b border-solid border-ui-grey-50 py-4 pl-0 pr-4 text-lg text-ui-dark hover:cursor-pointer hover:opacity-70 hover:transition-opacity hover:duration-[400] lg:w-auto lg:justify-normal lg:border-b-0 lg:py-4 lg:pl-0 lg:pr-1',
})

export const navigationMenuTrigger = tv({
  extend: sharedTextTrigger,
  base: 'group justify-between gap-x-2.5',
})

const sharedTextLink = tv({
  base: 'duration-400 grid w-full grid-flow-col items-center gap-x-1 border-b border-solid border-ui-grey-50 py-4 pl-0 pr-4 text-lg text-ui-dark transition hover:cursor-pointer hover:opacity-70 lg:w-auto lg:justify-normal lg:border-b-0 lg:py-4 lg:pl-0 lg:pr-1',
})

export const navigationMenuLink = tv({
  extend: sharedTextLink,
  base: 'no-underline',
})
export const navigationMenu = tv({
  slots: {
    content:
      'flex max-h-screen w-full flex-col overflow-auto bg-ui-light px-6 pb-40 pt-0 lg:flex-row lg:justify-end lg:px-20 lg:py-6 lg:pt-0',
    root: 'flex w-full flex-1 flex-shrink px-6 py-0 text-center lg:w-auto lg:items-center lg:justify-end lg:p-0 [&>div:first-child]:w-full lg:[&>div:first-child]:w-auto',
    list: 'w-full flex-col whitespace-nowrap lg:grid lg:w-auto lg:grid-flow-col lg:flex-row lg:gap-x-8 lg:px-4',
    viewport:
      'absolute left-0 top-0 h-full w-full origin-[top_center] bg-ui-light transition-[height] duration-300 ease-linear data-[state=closed]:animate-exit-to-right data-[state=open]:animate-enter-from-right lg:fixed lg:top-[72px] lg:h-[var(--radix-navigation-menu-viewport-height)] lg:data-[state=closed]:animate-scale-out-animation lg:data-[state=open]:animate-scale-in-animation',
  },
  variants: {
    hasCampaign: {
      true: {
        viewport: 'lg:top-[116px]',
      },
    },
  },
})
